import { useState } from "react";

import useSelectedPatient from "@/hooks/useSelectedPatient";
import Navigation from "@/components/Navigation/Navigation";
import PatientDetailsPageHeader from "@/components/PatientDetailsPageHeader/PatientDetailsPageHeader";
import PatientDetailsPageMain from "@/components/PatientDetailsPageMain/PatientDetailsPageMain";
import AppointmentsSearchDrayer from "@/components/AppointmentsComponents/AppointmentsSearchDrayer/AppointmentsSearchDrawer";

import "@/shared/styles/layout.scss";
import ToothFormulaScreen from "@/components/ToothFormulaScreen/ToothFormulaScreen";

export default function PatientDetailsPage() {
    const [open, setOpen] = useState<boolean>(false);
    const isExistuser = false;
    const isEditEntity = true;
    useSelectedPatient();

    function toggleDrawer(isOpen: boolean): void {
        setOpen(isOpen);
    }

    return (
        <div className='container'>
            <Navigation />
            <PatientDetailsPageHeader />
            <PatientDetailsPageMain toggleDrawer={toggleDrawer} />
            <AppointmentsSearchDrayer
                toggleDrawer={toggleDrawer}
                open={open}
                isExistuser={isExistuser}
                isEditEntity={isEditEntity}
            />
            <ToothFormulaScreen />
        </div>
    );
}
